import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {UI, Tags} from '../';

class TagPanel extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'TagPanel';
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(tags) {
    	this.props.updateTags(tags);
    }
    render() {
    	var tags = [];
    	if(typeof this.props.post.tags === 'object')
    		tags = this.props.post.tags;
    	console.log(this.props.post);
        return (
        	<UI.Panel title="Tags">
        		<Tags tags={tags} onChange={this.handleChange} />
        	</UI.Panel>
        )
    }
}


var mapStateToProps = function(state) {
	return {
		connection : state.connection,
		post : state.post
	}
}

var mapDispatchersToProps = function(dispatch) {
	return {
		updateTags : function(tags) {
			console.log(tags);
			dispatch({type: 'UPDATE_POST_TAGS', tags:tags });
		}
	}
}

export default connect(mapStateToProps,mapDispatchersToProps)(TagPanel);



// WEBPACK FOOTER //
// ./src/browser/components/posts/tagPanel.js